import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, post } from 'utils/api';
import { logError } from 'utils/log';

const { SOV } = API.END_POINTS;

const AUDIENCE_LOADING = 'sov/AUDIENCE_LOADING';
const AUDIENCE_LOADED = 'sov/AUDIENCE_LOADED';
const AUDIENCE_RESET = 'sov/AUDIENCE_RESET';

import type { Action, Dispatch, SOVAudience, ThunkAction } from 'types';
import type { SOVReport } from 'modules/insights/sov/types';

const initialState = {
  audience: [],
  isLoading: false
};

const setLoadingStatus = (type: string, status: boolean): Action => ({
  type,

  payload: {
    status
  }
});

const audienceLoaded = (results: Array<SOVAudience>): Action => ({
  type: AUDIENCE_LOADED,

  payload: {
    results
  }
});

export const resetAudience = (): Action => ({
  type: AUDIENCE_RESET
});

export const fetchAudienceData = (report: SOVReport): ThunkAction => async (dispatch: Dispatch) => {
  dispatch(setLoadingStatus(AUDIENCE_LOADING, true));

  try {
    const url = SOV.getAudienceData(report.id);
    const response = await post(url, { data: report });
    const results = response.data || {};

    dispatch(audienceLoaded(results));
    dispatch(setLoadingStatus(AUDIENCE_LOADING, false));
  } catch (e) {
    dispatch(setLoadingStatus(AUDIENCE_LOADING, false));
    logError(e);
  }
};

export default createReducer<any, any>('sovAudience', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [AUDIENCE_LOADING]: (state, { status }) => ({
    ...state,
    isLoading: status
  }),
  [AUDIENCE_LOADED]: (state, { results }) => ({
    ...state,
    audience: results
  }),
  [AUDIENCE_RESET]: (state) => ({
    ...state,
    audience: []
  })
});
